module.exports = __webpack_public_path__ + "media/2.b4c7653f.wav";